<header class="header-2">
  <div class="branding">
    <span class="title">{{ 'Profil-Viewer' | mrTranslate }} {{ objektname }}</span>
  </div>

  <div class="header-actions">
    <clr-checkbox-container style="margin-top: 17px; padding-right: 10px">
      <clr-checkbox-wrapper>
        <input
          type="checkbox"
          clrToggle
          name="options"
          value="false"
          [(ngModel)]="showdimensioning"
          (ngModelChange)="onDimensioningChange($event)" />
        <label style="color: white">{{ 'zeige Bemassung' | mrTranslate }}</label>
      </clr-checkbox-wrapper>
    </clr-checkbox-container>

    @if (selections()) {
      <div>
        <clr-combobox-container style="margin-top: 18px; padding-right: 10px">
          <clr-combobox
            [ngModel]="selection_()"
            (ngModelChange)="selection_.set($event)"
            (clrSelectionChange)="selectionProfileChanged($event)"
            name="multiSelect"
            clrMulti="true">
            <ng-container *clrOptionSelected="let selected">
              {{ selected?.datum }}
            </ng-container>
            <clr-options>
              <clr-option *clrOptionItems="let item of selections(); field: 'datum'" [clrValue]="item">
                {{ item.datum }}
              </clr-option>
            </clr-options>
          </clr-combobox>
        </clr-combobox-container>
      </div>
    }
    <clr-dropdown>
      <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
        <cds-icon shape="cog" />
      </button>
      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
        <!-- <a (click)="getHeightWearDia()" clrDropdownItem>{{'zeige Höhenverschleiß Diagramm' | mrTranslate}}</a> -->
        <a (click)="getMesswerte()" clrDropdownItem>{{ 'zeige Messwerte' | mrTranslate }}</a>
      </clr-dropdown-menu>
    </clr-dropdown>
    <a href="javascript://" class="nav-link nav-icon">
      <cds-icon shape="times" (click)="close()"></cds-icon>
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper">
  <div id="profileViewerWrapper">
    <!-- ===================== INFO SECTION ===================== -->
    <div class="clr-row nxm">
      <div class="clr-col-12 clr-col-sm-6 clr-col-md-3">
        <p class="mt-0">
          <strong>{{ 'links' | mrTranslate }}</strong>
          <br />
          <strong>{{ 'Name' | mrTranslate }}:</strong>
          {{ pr.l }}
          <br />
          <strong>{{ 'Position' | mrTranslate }}</strong>
          {{ pr.weg }}
        </p>
      </div>

      <div class="clr-col-12 clr-col-sm-6 clr-col-md-3">
        <p class="mt-0">
          <strong>∆S1:</strong>
          {{ ds.l1 }}
          <br />
          <strong>∆S2:</strong>
          {{ ds.l2 }}
          <br />
          <strong>∆H:</strong>
          {{ ds.lh }}
        </p>
      </div>

      <div class="clr-col-12 clr-col-sm-6 clr-col-md-3">
        <p class="mt-0">
          <strong>{{ 'rechts' | mrTranslate }}</strong>
          <br />
          <strong>{{ 'Name' | mrTranslate }}:</strong>
          {{ pr.r }}
          <br />
        </p>
      </div>

      <div class="clr-col-12 clr-col-sm-6 clr-col-md-3">
        <p class="mt-0">
          <strong>∆S1:</strong>
          {{ ds.r1 }}
          <br />
          <strong>∆S2:</strong>
          {{ ds.r2 }}
          <br />
          <strong>∆H:</strong>
          {{ ds.rh }}
        </p>
      </div>
    </div>

    <!-- ===================== LOADER ===================== -->
    @if (isLoading) {
      <clr-spinner class="centred"></clr-spinner>
    }

    <!-- ===================== GRAPHS ===================== -->
    @if (graphL.show) {
      <div class="card-block w-100">
        <div class="clr-row">
          <div id="plotly_Left" class="clr-col-12 clr-col-md-6"></div>
          <div id="plotly_Right" class="clr-col-12 clr-col-md-6"></div>
        </div>
      </div>
    }

    <!-- ===================== CONTROL BUTTONS ===================== -->

    @if (rechte() > 4) {
      <div class="clr-row mt-3">
        <!-- LEFT SIDE CONTROLS -->
        <div class="clr-col-12 clr-col-md-6 button-group">
          <button type="button" (click)="doMove(-moveStepL, 'L', 'Y')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="up"></cds-icon>
          </button>
          <button type="button" (click)="doMove(-moveStepL, 'L', 'X')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="left"></cds-icon>
          </button>
          <button type="button" (click)="doMove(moveStepL, 'L', 'X')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="right"></cds-icon>
          </button>
          <button type="button" (click)="doMove(moveStepL, 'L', 'Y')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="down"></cds-icon>
          </button>
          <button type="button" (click)="saveProfile('L')" class="btn btn-icon btn-primary">
            <cds-icon shape="floppy"></cds-icon>
          </button>
          <input type="number" value="1.0" step="0.1" (change)="setMoveStep($event, 'L')" class="move-input" />
          mm
        </div>
        <!-- RIGHT SIDE CONTROLS -->
        <div class="clr-col-12 clr-col-md-6 button-group">
          <button type="button" (click)="doMove(-moveStepR, 'R', 'Y')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="up"></cds-icon>
          </button>
          <button type="button" (click)="doMove(-moveStepR, 'R', 'X')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="left"></cds-icon>
          </button>
          <button type="button" (click)="doMove(moveStepR, 'R', 'X')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="right"></cds-icon>
          </button>
          <button type="button" (click)="doMove(moveStepR, 'R', 'Y')" class="btn btn-icon btn-primary">
            <cds-icon shape="arrow" direction="down"></cds-icon>
          </button>
          <button type="button" (click)="saveProfile('R')" class="btn btn-icon btn-primary">
            <cds-icon shape="floppy"></cds-icon>
          </button>
          <input type="number" value="1.0" step="0.1" (change)="setMoveStep($event, 'R')" class="move-input" />
          mm
        </div>
      </div>
    }

    <!-- ===================== SLIDER ===================== -->
    <div class="clr-row mt-4 custom-slider">
      <div class="clr-col-12">
        <ngx-slider
          [value]="currentIndex()"
          [options]="slideroptions"
          (valueChange)="onSliderChange($event)"></ngx-slider>
        <!-- <ngx-slider [(value)]="ind" [options]="slideroptions"></ngx-slider> -->
      </div>
    </div>
  </div>

  <clr-modal [(clrModalOpen)]="showmesswerte" [clrModalSize]="'xl'">
    <h3 class="modal-title">{{ 'Messwerte' | mrTranslate }} - {{ pr.weg }}</h3>
    <div class="modal-body">
      <form clrForm>
        <div class="limit-height1">
          <clr-datagrid class="datagrid-compact">
            <clr-dg-column>lx</clr-dg-column>
            <clr-dg-column>ly</clr-dg-column>
            <clr-dg-column>rx</clr-dg-column>
            <clr-dg-column>ry</clr-dg-column>
            @for (d of exportData; track d) {
              <clr-dg-row>
                <clr-dg-cell>{{ d.lX }}</clr-dg-cell>
                <clr-dg-cell>{{ d.lY }}</clr-dg-cell>
                <clr-dg-cell>{{ d.rX }}</clr-dg-cell>
                <clr-dg-cell>{{ d.rY }}</clr-dg-cell>
              </clr-dg-row>
            }
            <clr-dg-footer>{{ 'Anzahl' | mrTranslate }}: {{ exportData.length }}</clr-dg-footer>
          </clr-datagrid>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="doExcelExport()">
        {{ 'Excel export' | mrTranslate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="showmesswerte = false">
        {{ 'Schließen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>

  <clr-modal [(clrModalOpen)]="showWearDia" [clrModalSize]="'xl'">
    <h3 class="modal-title">{{ 'Höhenverschleiß' | mrTranslate }}</h3>

    <div class="modal-body">
      <div #plotDiv style="width: 100%; height: 500px">
        <app-plotly-plot
          #wearPlot
          [data]="graphWear.data"
          [layout]="graphWear.layout"
          [config]="graphWear.config"
          [style]="graphWear.style"></app-plotly-plot>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="showWearDia = false">
        {{ 'Schließen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
</div>
